import { type ReactElement } from 'react';
import classnames from 'classnames';
import { BuyerProductTileShimmer } from 'dibs-buyer-product-tile/exports/BuyerProductTileShimmer.ts';
import { TILE_SIZES } from 'dibs-buyer-product-tile/exports/BuyerProductTile.ts';
import dibsCss from 'dibs-css';

import { getHpPersonalizedMixedGridProductTileSize } from './buildHpPersonalizedMixedGrid.ts';

type GetHpPersonalizedMixedGridShimmerItemsProps = {
    count: number;
    startIndex: number;
    isMobile: boolean;
    loadMoreTracker?: ReactElement | null;
};

export function getHpPersonalizedMixedGridShimmerItems({
    count,
    startIndex,
    isMobile,
    loadMoreTracker,
}: GetHpPersonalizedMixedGridShimmerItemsProps): ReactElement[] {
    return Array.from({ length: count }, (_, offset) => {
        const slotIndex = startIndex + offset;
        const size = isMobile
            ? TILE_SIZES.small
            : getHpPersonalizedMixedGridProductTileSize(slotIndex);

        return (
            <div
                key={`hp-personalized-mixed-grid-shimmer-${slotIndex}`}
                className={classnames(dibsCss.minW0, dibsCss.relative)}
                data-tn="hp-personalized-mixed-grid-shimmer"
            >
                {offset === 0 && loadMoreTracker ? (
                    <div
                        className={classnames(
                            dibsCss.absolute,
                            dibsCss.wFull,
                            dibsCss.pointerEventsNone
                        )}
                    >
                        {loadMoreTracker}
                    </div>
                ) : null}
                <BuyerProductTileShimmer size={size} />
            </div>
        );
    });
}
